import React, { ReactNode, useState } from "react";
import * as Popover from "@radix-ui/react-popover";
import clsx from "clsx";

const Tooltip = ({
  children,
  text,
  ariaLabel,
}: {
  children: ReactNode;
  text: string;
  ariaLabel?: string;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover.Root onOpenChange={setOpen} open={open}>
      <Popover.Trigger
        asChild
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <button aria-label={ariaLabel ?? "Show Tooltip"}>{children}</button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          align="center"
          sideOffset={7}
          side="top"
          onOpenAutoFocus={(event) => event.preventDefault()}
          onCloseAutoFocus={(event) => event.preventDefault()}
          className={clsx(
            "edwt__tooltip__content",
            "dark:bg-gray-800 z-50 w-48 rounded-lg bg-white p-3 text-sm shadow-md md:w-56",
          )}
        >
          <Popover.Arrow className="edwt__tooltip__arrow" />
          {text}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default Tooltip;
